import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { sendVerificationEmailSuccess, sendVerificationEmailRequest } from '../../slices/user';

function* sendVerificationEmailWorker() {
  let errorMessage = 'An error occured while processing your request!';
  try {
    const url = '/users/sendVerificationEmail';
    const config = {
      method: 'POST',
      url,
    };
    const { data } = yield call(axios, config);
    yield put(sendVerificationEmailSuccess({ error: !data ? errorMessage : undefined }));
  } catch (error) {
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(sendVerificationEmailSuccess({ error: errorMessage }));
    console.error(error);
  }
}

function* sendVerificationEmailWatcher() {
  yield takeLatest(sendVerificationEmailRequest.toString(), sendVerificationEmailWorker);
}

export default sendVerificationEmailWatcher;
